module.exports = __webpack_public_path__ + "static/media/bluecat.b706c6bf.png";